export function Analytics() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-slate-900">Analytics</h1>
      <p className="text-sm text-slate-500">Historical trends and performance analytics.</p>
      <div className="rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <p className="text-slate-400">Analytics charts will be rendered here.</p>
      </div>
    </div>
  )
}
